import { api } from '../../../shared/api/axios';
import { toast } from 'react-hot-toast';
import { logError } from '../../../shared/utils/errorUtils';
import type {
  Notification,
  NotificationPreferences,
} from '../types/notifications';

// Get all notifications for the current user
export const getNotifications = async (): Promise<Notification[]> => {
  try {
    return await api.get<Notification[]>('/notifications/');
  } catch (error) {
    logError(error, 'getNotifications');
    throw error;
  }
};

// Mark a notification as read
export const markAsRead = async (notificationId: string): Promise<void> => {
  try {
    await api.patch(`/notifications/${notificationId}/read/`);
  } catch (error) {
    logError(error, 'markAsRead');
    throw error;
  }
};

// Mark all notifications as read
export const markAllAsRead = async (): Promise<void> => {
  try {
    await api.post('/notifications/mark-all-read/');
  } catch (error) {
    logError(error, 'markAllAsRead');
    throw error;
  }
};

// Delete a notification
export const deleteNotification = async (
  notificationId: string
): Promise<void> => {
  try {
    await api.delete(`/notifications/${notificationId}/`);
  } catch (error) {
    logError(error, 'deleteNotification');
    throw error;
  }
};

// Get user notification preferences
export const getNotificationPreferences =
  async (): Promise<NotificationPreferences> => {
    try {
      return await api.get<NotificationPreferences>(
        '/notifications/preferences/'
      );
    } catch (error) {
      logError(error, 'getNotificationPreferences');
      throw error;
    }
  };

// Update user notification preferences
export const updateNotificationPreferences = async (
  preferences: NotificationPreferences
): Promise<void> => {
  try {
    await api.patch('/notifications/preferences/', preferences);
  } catch (error) {
    logError(error, 'updateNotificationPreferences');
    throw error;
  }
};

// Send a test notification
export const sendTestNotification = async (type: string): Promise<void> => {
  try {
    await api.post('/notifications/test/', { type });
    toast.success('Test notification sent');
  } catch (error) {
    logError(error, 'sendTestNotification');
    throw error;
  }
};
